/**
 * @generated SignedSource<<9f7b3a21fc6918c2632c842a497f48b5>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
export type ConfluencePageSubType = "LIVE" | "%future added value";
export type SearchLinkedResultCategory = "child" | "mentionedBy" | "mentions" | "similar" | "%future added value";
export type SearchResultType = "ask" | "attachment" | "blogpost" | "board" | "comment" | "component" | "dashboard" | "database" | "document" | "embed" | "filter" | "focus_area" | "focus_area_status_update" | "folder" | "goal" | "goal_update" | "issue" | "learning" | "message" | "object" | "page" | "plan" | "position" | "presentation" | "project" | "project_update" | "question" | "repository" | "schema" | "slide" | "space" | "spreadsheet" | "tag" | "type" | "unrecognised" | "video" | "whiteboard" | "%future added value";
import type { FragmentRefs } from "relay-runtime";
export type searchConfluencePageBlogAttachment_AtlassianSearchPage$data = {
  readonly __typename: "SearchConfluencePageBlogAttachment";
  readonly confluenceEntity: {
    readonly commentCountSummary?: {
      readonly total: number | null | undefined;
    } | null | undefined;
    readonly likesSummary?: {
      readonly count: number | null | undefined;
    } | null | undefined;
    readonly subtype?: ConfluencePageSubType | null | undefined;
  } | null | undefined;
  readonly description: string;
  readonly iconUrl?: string | null | undefined;
  readonly id: string;
  readonly isVerified: boolean;
  readonly lastModified: string | null | undefined;
  readonly linkedResults: ReadonlyArray<{
    readonly category: SearchLinkedResultCategory;
    readonly connectorType: string | null | undefined;
    readonly description: string;
    readonly id: string;
    readonly integrationId: string | null | undefined;
    readonly lastModifiedDate: string | null | undefined;
    readonly providerId: string | null | undefined;
    readonly subtype: string | null | undefined;
    readonly title: string;
    readonly type: SearchResultType;
    readonly url: string;
  }> | null | undefined;
  readonly navBoostScore?: number | null | undefined;
  readonly socialSignal: {
    readonly signal: string | null | undefined;
    readonly timestamp: string | null | undefined;
    readonly user: {
      readonly accountId: string;
      readonly email?: string | null | undefined;
      readonly extendedProfile?: {
        readonly jobTitle: string | null | undefined;
      } | null | undefined;
      readonly name: string;
      readonly picture: AGG$URL;
    } | null | undefined;
  } | null | undefined;
  readonly space: {
    readonly id: string;
    readonly name: string | null | undefined;
    readonly webUiLink: string | null | undefined;
  } | null | undefined;
  readonly title: string;
  readonly type: SearchResultType;
  readonly url: string;
  readonly " $fragmentType": "searchConfluencePageBlogAttachment_AtlassianSearchPage";
};
export type searchConfluencePageBlogAttachment_AtlassianSearchPage$key = {
  readonly " $data"?: searchConfluencePageBlogAttachment_AtlassianSearchPage$data;
  readonly " $fragmentSpreads": FragmentRefs<"searchConfluencePageBlogAttachment_AtlassianSearchPage">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "description"
},
v2 = {
  "kind": "ScalarField",
  "name": "title"
},
v3 = {
  "kind": "ScalarField",
  "name": "type"
},
v4 = {
  "kind": "ScalarField",
  "name": "url"
},
v5 = {
  "kind": "ScalarField",
  "name": "name"
},
v6 = {
  "kind": "ScalarField",
  "name": "subtype"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeIconUrl"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "includeNavBoostScore"
    },
    {
      "kind": "RootArgument",
      "name": "tenantId"
    }
  ],
  "kind": "Fragment",
  "name": "searchConfluencePageBlogAttachment_AtlassianSearchPage",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "__typename"
    },
    (v0/*: any*/),
    (v1/*: any*/),
    (v2/*: any*/),
    (v3/*: any*/),
    (v4/*: any*/),
    {
      "kind": "ScalarField",
      "name": "lastModified"
    },
    {
      "kind": "ScalarField",
      "name": "isVerified"
    },
    {
      "condition": "includeIconUrl",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "iconUrl"
        }
      ]
    },
    {
      "condition": "includeNavBoostScore",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "navBoostScore"
        }
      ]
    },
    {
      "concreteType": "SearchConfluenceResultSpace",
      "kind": "LinkedField",
      "name": "space",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        (v5/*: any*/),
        {
          "kind": "ScalarField",
          "name": "webUiLink"
        }
      ]
    },
    {
      "kind": "LinkedField",
      "name": "confluenceEntity",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            (v6/*: any*/),
            {
              "concreteType": "ConfluenceCommentCountSummary",
              "kind": "LinkedField",
              "name": "commentCountSummary",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "total"
                }
              ]
            },
            {
              "concreteType": "ConfluenceLikesSummary",
              "kind": "LinkedField",
              "name": "likesSummary",
              "plural": false,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "count"
                }
              ]
            }
          ],
          "type": "ConfluencePage"
        }
      ]
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "tenantId",
          "variableName": "tenantId"
        }
      ],
      "concreteType": "SocialSignalSearch",
      "kind": "LinkedField",
      "name": "socialSignal",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "signal"
        },
        {
          "kind": "ScalarField",
          "name": "timestamp"
        },
        {
          "kind": "LinkedField",
          "name": "user",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "accountId"
            },
            (v5/*: any*/),
            {
              "kind": "ScalarField",
              "name": "picture"
            },
            {
              "kind": "InlineFragment",
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "email"
                },
                {
                  "concreteType": "AtlassianAccountUserExtendedProfile",
                  "kind": "LinkedField",
                  "name": "extendedProfile",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "ScalarField",
                      "name": "jobTitle"
                    }
                  ]
                }
              ],
              "type": "AtlassianAccountUser"
            }
          ]
        }
      ]
    },
    {
      "concreteType": "SearchLinkedResult",
      "kind": "LinkedField",
      "name": "linkedResults",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        (v2/*: any*/),
        (v4/*: any*/),
        (v3/*: any*/),
        (v1/*: any*/),
        {
          "kind": "ScalarField",
          "name": "lastModifiedDate"
        },
        {
          "kind": "ScalarField",
          "name": "category"
        },
        (v6/*: any*/),
        {
          "kind": "ScalarField",
          "name": "integrationId"
        },
        {
          "kind": "ScalarField",
          "name": "providerId"
        },
        {
          "kind": "ScalarField",
          "name": "connectorType"
        }
      ]
    }
  ],
  "type": "SearchConfluencePageBlogAttachment"
};
})();

(node as any).hash = "8a2e47b7232da07cc9c5817ff662b1e1";

export default node;
